import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const EditSvg = () => (
  <svg width='1em' height='1em' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M14.6665 5.3335H5.33317C4.62593 5.3335 3.94765 5.61445 3.44755 6.11454C2.94746 6.61464 2.6665 7.29292 2.6665 8.00016V26.6668C2.6665 27.3741 2.94746 28.0524 3.44755 28.5524C3.94765 29.0525 4.62593 29.3335 5.33317 29.3335H23.9998C24.7071 29.3335 25.3854 29.0525 25.8855 28.5524C26.3856 28.0524 26.6665 27.3741 26.6665 26.6668V17.3335'
      stroke='currentColor'
      strokeWidth='1.7'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M24.6665 3.33331C25.1969 2.80288 25.9164 2.50488 26.6665 2.50488C27.4166 2.50488 28.1361 2.80288 28.6665 3.33331C29.1969 3.86374 29.4949 4.58316 29.4949 5.33331C29.4949 6.08346 29.1969 6.80288 28.6665 7.33331L15.9998 20L10.6665 21.3333L11.9998 16L24.6665 3.33331Z'
      stroke='currentColor'
      strokeWidth='1.7'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const EditIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={EditSvg} {...props} />
);
